window.addEventListener('DOMContentLoaded', () => {
  
  // Configuración inicial:
  let globalCities = [];
  let globalLocations = [];

  const locationUserSettings = {
    "shippingType": "shipping",
    "city": "",
    "store": ""
  }; 

  console.log('Location User Settings: ', locationUserSettings);

  (async () => {

    // Constantes: 
    const form = document.querySelector(".location__form"); 
    const modal = document.querySelector(".location__modal-wrapper");
    const action = document.querySelector('.location__modal-action'); // Botón de guardar del modal
    const close = document.querySelector(".location__modal-close");
    const selectLevel1 = document.getElementById("level-1");
    const selectLevel2 = document.getElementById("level-2");

    const url = window.location.href;

    // Configuración de credenciales: 
    // const accessToken = "3c131aaf1fe1d52eaf9a22a4520398ea";
    // const endpoint = "https://testing-colombia-ce.myshopify.com/api/2024-10/graphql.json";
    const accessToken = "2c137203d90c2b306f650a600486531b";
    const endpoint = "https://crocs-shop-colombia.myshopify.com/api/2024-10/graphql.json";  

    // Local Storage:
    // localStorage.setItem('locationUserSettingsOpenedByUser', false);
    // localStorage.setItem('locationUserSettingsClosed', false); 
    // localStorage.setItem('locationUserSettingsSaved', false);
  
    if(action){ 
      action.addEventListener('click', (e)=> {
        e.preventDefault();

 
     

        // Tipos de envios: Envio a domicilio - Retiro en tienda
        const shippingTypes = document.querySelectorAll('.location__modal-type-options .location__modal-type-option');  
        // console.log('TYPES: ', shippingTypes);
        
        if(shippingTypes && form) {
          shippingTypes.forEach(type => {
            if(type.classList.contains('location__modal-type-option--active')){
              // console.log(type);

              if(type.dataset.locationOption.trim() === 'shipping'){                
                
                locationUserSettings.shippingType = type.dataset.locationOption.trim();
                locationUserSettings.city = "";
                locationUserSettings.store = "";
                localStorage.setItem('locationUserSettings', JSON.stringify(locationUserSettings));
                modal.style.display = "none";
                
                setSelectedStore();

                localStorage.setItem('locationUserSettingsSaved', true);

                window.location.reload();

              } else {            

                const options = form.querySelectorAll('.location__form-item .location__select');
                // console.log(options);
                
                const values = Array.from(options).map((option) => option.value.trim() !== "");
                // console.log('Values: ', values);
                
                const validation = values.every(value => value === true);
                // console.log(validation);

                removeError();

                if(values.includes(false)){
                  form.insertAdjacentHTML('beforeend', `<span id="location__error" class="location__error">Debes seleccionar la ciudad y la tienda.</span>`);
                }
          
                if(validation === true){               
                  locationUserSettings.city = selectLevel1.value;
                  locationUserSettings.store = selectLevel2.value;     
                  locationUserSettings.shippingType = "pickup";

                  localStorage.setItem('locationUserSettings', JSON.stringify(locationUserSettings)); 
                  modal.style.display = "none";    

                  setSelectedStore();
                  
                  localStorage.setItem('locationUserSettingsSaved', true);

                  window.location.reload();
                }              
                
              }
              
            }
          });
        }
        
        
        // window.location.reload();
       

      });
    }

      // Botón para cerrar el modal de Locations:

    if (close) {
      close.addEventListener("click", () => {
        // console.log("click");        
        if (modal) {
          modal.style.display = "none";
          localStorage.setItem('locationUserSettingsClosed', true); 
        }

        if(!localStorage.getItem('locationUserSettingsOpenedByUser') && localStorage.getItem('locationUserSettingsClosed') == 'true' && !localStorage.getItem('locationUserSettingsSaved')){
          setTimeout(() => {
            console.log('Mostrando tooltip...');
            const locationTooltip = document.getElementById('location-tooltip');
            locationTooltip.style.display = 'flex';
          }, 3000)
        }

      });
    }

    document.querySelectorAll(".location__modal-type-option").forEach((option) => {

        if(localStorage.getItem('locationUserSettings') !== null) { // Si la configuración tiene valores en el local storage.
          const locationUserSettings = JSON.parse(localStorage.getItem('locationUserSettings'));
          console.log('Locacion Parse: ', locationUserSettings);

          if (form && option.dataset.locationOption === "shipping" && locationUserSettings.shippingType === "shipping") {

            option.classList.add('location__modal-type-option--active');
            locationUserSettings.city = "";
            locationUserSettings.store = "";
            form.style.display = "none";
            localStorage.setItem('locationUserSettings', JSON.stringify(locationUserSettings));

          } else if(form && option.dataset.locationOption === "pickup" && locationUserSettings.shippingType === "pickup") {

            option.classList.add('location__modal-type-option--active');
            form.style.display = "flex";

          }        
        }
        
        option.addEventListener("click", () => {

          // Remover la clase "active" de todos los elementos
          document.querySelectorAll(".location__modal-type-option").forEach((el) =>
            el.classList.remove("location__modal-type-option--active")
          );

          // Agregar la clase "active" al elemento clickeado
          option.classList.add("location__modal-type-option--active");
          locationUserSettings.shippingType = option.dataset.locationOption.trim();

          if (form && option.dataset.locationOption === "shipping") {

            locationUserSettings.city = "shipping";
            locationUserSettings.city = "";
            locationUserSettings.store = "";
            form.style.display = "none";

          } else {

            form.style.display = "flex";

          }
        });
      });


    // Función para setear el valor seleccionado: 
    function setSelectedStore(){
      const locationUserSettings = JSON.parse(localStorage.getItem('locationUserSettings'));
      const locationOption = document.getElementById('location-option');
      const locationAction = document.getElementById('location-action');

      console.log('Location User Settings: ', locationUserSettings);

      if(locationUserSettings && locationOption && locationAction){

        locationOption.textContent = '';
        locationAction.textContent = '';

        if(locationUserSettings.shippingType === "pickup"){
          locationOption.textContent = `${locationUserSettings.store}`;
          locationAction.textContent = `CAMBIAR`;
        } else {
          locationOption.textContent = `Envío a domicilio`;
          locationAction.textContent = `CAMBIAR`;
        }
      }  
    } 

    setSelectedStore();

    // Función para realizar las peticiones GraphQL.
    async function fetchShopifyData(query, endpoint, accessToken) {
      try {
        const response = await fetch(endpoint, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Shopify-Storefront-Access-Token": accessToken,
          },
          body: JSON.stringify({ query }),
        });

        if (!response.ok) {
          throw new Error(`Error: ${response.status} - ${response.statusText}`);
        }

        const data = await response.json();
        return data;
        
      } catch (error) {
        console.error("Error fetching Shopify data:", error);
        return null;
      }
    }

    // Función para traer todas las Locations.
    async function fetchAllLocations(quantity = 250) {

      const query = `
          query {
              locations (first: ${quantity}) {
                  nodes {
                      id
                      name
                      address {
                          address1
                          address2
                          city
                          country
                          countryCode
                          formatted
                          latitude
                          longitude
                          phone
                          province
                          provinceCode
                          zip
                      }
                  }
                  pageInfo {
                      endCursor 
                      hasNextPage
                      hasPreviousPage
                      startCursor
                  }
              }
          }`;

      const data = await fetchShopifyData(query, endpoint, accessToken);
      const locations = data.data.locations.nodes;

      return locations;
    }

    // Función para configurar los selects.
    function setCity(locations) {
      globalCities = [...new Set(locations.map((location) => location.address.city))];
      globalLocations = locations.map((location) => [location.name, location.address.city,]);
      populateLevel1Select(globalCities, globalLocations);
    }

    // Paso 1: 
    // Llamado de la función de Locations:
    console.log("Locations:");
    fetchAllLocations().then((locations) => {
      setCity(locations);
    });

    
    function setModalConfiguration(){
      
      const modal = document.querySelector(".location__modal-wrapper");

      if (modal) {        

        if (localStorage.getItem('locationUserSettings') === null){ // Si no existe, lo configura en el local storage. 

          localStorage.setItem('locationUserSettings', JSON.stringify(locationUserSettings));

        } else {

          if(JSON.parse(localStorage.getItem('locationUserSettings')).city !== null && JSON.parse(localStorage.getItem('locationUserSettings')).store !== null){
            // Remover la clase "active" de todos los elementos: 
            document.querySelectorAll(".location__modal-type-option").forEach((el) => {
                el.classList.remove("location__modal-type-option--active");                
                if (el.dataset.locationOption === JSON.parse(localStorage.getItem('locationUserSettings')).shippingType){
                  el.classList.add("location__modal-type-option--active")
                }
              }
            );
          }
          
          if (JSON.parse(localStorage.getItem('locationUserSettings')).shippingType === 'pickup'){

            form.style.display = 'flex';

            if (JSON.parse(localStorage.getItem('locationUserSettings')).shippingType.city !== "" && JSON.parse(localStorage.getItem('locationUserSettings')).store !== ""){
            
              selectLevel1.value = JSON.parse(localStorage.getItem('locationUserSettings')).city.trim();                
     
              updateLevel2Select(globalCities, globalLocations, selectLevel2, JSON.parse(localStorage.getItem('locationUserSettings')).city.trim());
              
              if (selectLevel2.disabled === true){
                selectLevel2.disabled = false;
                selectLevel2.value = JSON.parse(localStorage.getItem('locationUserSettings')).store.trim();
              }else {
                selectLevel2.value = JSON.parse(localStorage.getItem('locationUserSettings')).store.trim();
              }

            }
          } else {

            form.style.display = "none";

          }
        }

        modal.style.display = "flex";
      }

    }

    // Botón de acción para mostrar el modal de Locations:
    const actionModal = document.querySelector(".location__wrapper");
    if (actionModal) {

      actionModal.addEventListener("click", () => {
        setModalConfiguration();        
        localStorage.setItem('locationUserSettingsOpenedByUser', true);
      });

      // Ocultar el tooltip al pasar el mouse por encima:
      actionModal.addEventListener('mouseenter', (e) => {
        e.preventDefault(); 
        // console.log('Hover:');
        const locationTooltip = document.getElementById('location-tooltip');
        if(locationTooltip){
          locationTooltip.style.display = 'none';
        }
      });
    }

     // Mostrar el modal después de un segundo de carga:
     if((!localStorage.getItem('locationUserSettingsSaved') && !localStorage.getItem('locationUserSettingsClosed')) && !url.includes('/cart')){
       setTimeout(() => setModalConfiguration(), 1000); 
     }


    // Función que retorna la información de las ciudades en los selectores:
    const populateLevel1Select = (cities, locations) => {
      // console.log("Llenando nivel 1: ");
      // console.log(cities);

      selectLevel1.innerHTML = "";

      // Rellena el primer select con los departamentos
      selectLevel1.insertAdjacentHTML('afterbegin',`<option value="" class="location__option" disabled selected>Ciudad</option>`);
      cities.forEach((city) => {
        // console.log("Ciudad: ", city);

        if(city === 'Bogotá'){ // Mientras, luego quitar
          const option = document.createElement("option");
          option.value = city;
          option.textContent = city;
          // selectLevel1.innerHTML = "";
          selectLevel1.appendChild(option);
        }


      });

      updateLevel2Select(cities, locations, selectLevel2, cities[0]);  

      // Agrega un listener para actualizar el segundo select
      selectLevel1.addEventListener("change", (e) => {
        // console.log(e);
        selectLevel2.disabled = false;
        const selectedDepartment = e.target.value;
        if (selectedDepartment !== "") {
          updateLevel2Select(cities, locations, selectLevel2, selectedDepartment);

          // Almacenar el valor seleccionado

          const selectedValue = selectLevel1.value;

          if (selectedValue) {
            console.log(`Ciudad de envio seleccionada: ${selectedValue}`);
            locationUserSettings.city = selectedValue;
            locationUserSettings.store = "";  
            console.log('Location User Settings: ', locationUserSettings);

            removeError();
    
          } else {
            locationUserSettings.city = "";       
          }
    
        } else {
          selectLevel2.innerHTML = `<option value="" class="location__option" disabled selected>Ciudad</option>`;
        }
      });

      //
      selectLevel2.addEventListener("change", (e) => {
    
        const selectedCity = e.target.value;
        if (selectedCity !== "") {
          // Almacenar el valor seleccionado

          const selectedValue = selectLevel2.value;

          if (selectedValue) {
            console.log(`Tienda seleccionada: ${selectedValue}`);
            locationUserSettings.store = selectedValue;

            removeError();
    
          } else {
            locationUserSettings.store = "";
          }

        } else {
          selectLevel2.innerHTML = `<option value="" class="location__option" disabled selected>Tienda</option>`;
        }
      });
    };

    const updateLevel2Select = (cities, locations, selector, target) => {

      // console.log("Actualizando nivel 2: ");
      // console.log("Ciudades: ", cities);
      // console.log("Ubicaciones: ", locations);
      // console.log("Seleccionado: ", target);      
      // console.log("Target: ", target);
      
      selector.innerHTML = ""; // Limpia las opciones previas
      // selector.innerHTML = `<option value="" class="location__option" disabled selected>Tienda</option>`;
      selector.insertAdjacentHTML('afterbegin',`<option value="" class="location__option" disabled selected>Tienda</option>`);
      
      // Locations = [Tienda, Ciudad]
      const locationsByName = locations.reduce((acc, location) => {
        // console.log(location);
        if (location[1] === target && location[0] !== '82-85 Avenida Carrera 19') {
          acc.push(location[0]);
        }
        return acc;
      }, []);

      // console.log('Locations By Name: ', locationsByName);
      

      if (locationsByName) {
        locationsByName.forEach((city) => {    
          // console.log('By: ', city);
          const option = document.createElement("option");
          option.value = city;
          option.textContent = city;
          selector.appendChild(option);
          // console.log(selector);          
          // selector.dispatchEvent(new Event("change"));
        });
      }
    };

    if(localStorage.getItem('locationUserSettings') === null){ // Si no existe, lo configura en el local storage. 
      localStorage.setItem('locationUserSettings', JSON.stringify(locationUserSettings))
    } 

    // Función para remover mensajes de error
    function removeError() {
      const error = document.getElementById('location__error');
      if (error) error.remove();
    }
    
    function isLocationAvailable(products, locationName) {
      return products.some(product => {
        // Verificamos si hay algún nodo en storeAvailability que cumpla las condiciones
        return product.storeAvailability.nodes.some(node => {
          return node.available === true && node.location.name === locationName;
        });
      });
    }

    // Comentarizadas mientras: 

    // async function fetchProductsBySpecificCollection(accessToken, endpoint, collectionId) {

    //   console.log('Acces Token: ', accessToken);      
    //   console.log('Endpoint: ', endpoint);
    //   console.log('ID de la colección: ', collectionId);

    //   let hasNextPage = true;
    //   let endCursor = null;
    //   let allProducts = [];

    //   while (hasNextPage) {
    //     const query = `query getCollectionById($id: ID!) {
    //         collection(id: $id) {        
    //             title
    //             products (first: 250, after: ${endCursor ? `"${endCursor}"` : null}) {        
    //                 pageInfo {
    //                     hasNextPage
    //                     endCursor
    //                 }
    //                 nodes {
    //                     id
    //                     variants (first: 250) {
    //                         nodes {
    //                             product {
    //                               title
    //                             }
    //                             availableForSale
    //                             quantityAvailable
    //                             price {
    //                                 amount
    //                             }
    //                             selectedOptions {
    //                               name
    //                               value
    //                             }
    //                             requiresShipping
    //                             storeAvailability (first: 250) {
    //                                 nodes {
    //                                     available
    //                                     quantityAvailable
    //                                     location {
    //                                         name
    //                                     }
    //                                 }
    //                             }
    //                         }
    //                         pageInfo {
    //                             hasNextPage
    //                             endCursor
    //                         }
    //                     }
    //                 }
    //             }
    //         }
    //     }`;

    //     const variables = {
    //       id: String(collectionId)
    //     };

    //     const response = await fetch(endpoint, {
    //       method: "POST",
    //       headers: {
    //         "Content-Type": "application/json",
    //         "X-Shopify-Storefront-Access-Token": accessToken
    //       },
    //       body: JSON.stringify({ query, variables })
    //     });

    //     const data = await response.json();
    //     console.log(data);
    //     // console.log(data.data.collection.products.nodes);
    //     // console.log(data.data.collection.products.edges);

    //     const products = data.data.collection.products.nodes.map((node) => node);
    //     allProducts = allProducts.concat(products);

    //     hasNextPage = data.data.collection.products.pageInfo.hasNextPage;
    //     endCursor = data.data.collection.products.pageInfo.endCursor;

    //   }
      

    //   return allProducts;

    //   // console.log(allCollections);
      

    //   // await valiateLocation(data.data.collection.products);

    //   // return allCollections;
    
    //     //   .then(res => res.json())
    //     //   .then(data => {
          
    //     //     console.log(data);
    //     //     // console.log(data.data.collection.products.nodes[0].variants);        


    //     //     // Acceder dinámicamente sin asumir posiciones fijas
    //     // console.log(data.data.collection.products.nodes[0]);

    //     //     const nodes = data.data.collection.products.nodes[0];

    //     //     if(nodes){
    //     //       const { variants } = nodes;
    //     //       console.log(variants);
    //     //     }
            
    //     //   })
    //     //   .catch(error => console.error(error));

      
    // }

    // async function valiateProductLocation(products = "") {

    //   console.log('Collection Products: ', products);
      
    //   const productGrid = document.getElementById('product-grid');
    //   console.log(productGrid);

    //   const gridItems = productGrid.querySelectorAll('.grid__item');

    //   gridItems.forEach(item => {
    //     console.log(item);
    //     console.log(item.dataset.productId);


    //     products.forEach(product => {
    //       // console.log(product);
    //       if(product.id.includes(item.dataset.productId)){
    //         console.log('Incluye');
            
    //         // console.log('Variants: ');          
    //         // console.log(product.variants);
    //         // console.log('Nodes: ');   
    //         // console.log(product.variants.nodes);
    //         // console.log('Store Availability: ');   
    
    //         const variants = product.variants.nodes;

    //         console.log('Variantes: ', variants);
            

    //         const showItem = isLocationAvailable(variants, JSON.parse(localStorage.getItem('locationUserSettings')).store);
    //         console.log(showItem);

    //         if(showItem === false){
    //           item.remove();
    //         }
            
    
    //         // variants.forEach((variant, index) => {
    //         //     console.log(`Producto ${index + 1}: ${variant.product.title}`);
    
    //         //     // Acceder a storeAvailability
    //         //     const storeAvailability = variant.storeAvailability.nodes;
    
    //         //     // Verificar si hay disponibilidad en tiendas
    //         //     if (storeAvailability.length > 0) {




    //         //         console.log("Disponibilidad en tiendas:");
    //         //         storeAvailability.forEach((store, storeIndex) => {
    
    //         //             if(store.available === true){
    //         //               console.log(`    Ubicación: ${store.location.name}`);
                        
    //         //               if(store.location.name === localStorage.getItem('locationUserSettings').store){
    //         //                 // console.log(`    Tienda ${storeIndex + 1}:`);
    //         //                 // console.log(`    Disponible: ${store.available}`);
    //         //                 // console.log(`    Cantidad disponible: ${store.quantityAvailable}`);
    //         //                 // console.log(`    Ubicación: ${store.location.name}`);
    //         //                 // valiateProductLocation();
    //         //               }
    
    //         //             }
    
                    
    //         //         });
    //         //     } else {
    //         //         console.log("No hay disponibilidad en tiendas para este producto.");
    //         //     }
    
    //         //     console.log("-----------------------------");
    //         // });
            
          
            
    
    //         // console.log(product.variants.nodes[0].storeAvailability);
    //         // console.log('Store Availability Nodes: ');   
    //         // console.log(product.variants.nodes[0].storeAvailability.nodes[0]);
            
    //       }
    //     });

    //     if(item.dataset.productId){
          
    //     }
              
    //   });
      

    // };

    // async function fetchAllCollections(accessToken, endpoint) {

    //   let hasNextPage = true;
    //   let endCursor = null;
    //   let allCollections = [];
    
    //   while (hasNextPage) {
    //     const query = `
    //       query {
    //         collections(first: 250, after: ${endCursor ? `"${endCursor}"` : null}) {
    //           edges {
    //             cursor
    //             node {
    //               id
    //               title
    //               handle
    //             }
    //           }
    //           pageInfo {
    //             hasNextPage
    //             endCursor
    //           }
    //         }
    //       }
    //     `;

    //     const response = await fetch(endpoint, {
    //       method: 'POST',
    //       headers: {
    //         'Content-Type': 'application/json',
    //         'X-Shopify-Storefront-Access-Token': accessToken,
    //       },
    //       body: JSON.stringify({ query })
    //     });

    //     const data = await response.json();
    //     const collections = data.data.collections.edges.map((edge) => edge.node);
    //     allCollections = allCollections.concat(collections);

    //     hasNextPage = data.data.collections.pageInfo.hasNextPage;
    //     endCursor = data.data.collections.pageInfo.endCursor;
    //   }

    //   return allCollections;
    // }

    // async function fetchProduct(accessToken, endpoint, productId) {

    //   const query = `
    //     query getProductById($id: ID!) {
    //       product(id: $id) {
    //         id
    //         title
    //           featuredImage {
    //             url
    //         }
    //         variants (first: 250) {
    //           nodes {
    //             sku
    //             availableForSale
    //             quantityAvailable
    //             price {
    //               amount
    //             }                
    //             compareAtPrice {
    //               amount
    //             }
    //             selectedOptions {
    //               name
    //               value
    //             }
    //             requiresShipping
    //             storeAvailability (first: 250) {
    //               nodes {                  
    //                 available
    //                 quantityAvailable
    //                 location {
    //                   name
    //                   address {
    //                     city                      
    //                   }                    
    //                 }
    //               }
    //             }
    //           }
    //         }
    //       }
    //     }
    //   `;

    //   const variables = {
    //     id: String(productId)
    //   };

    //   const response = await fetch(endpoint, {
    //     method: "POST",
    //     headers: {
    //       "Content-Type": "application/json",
    //       "X-Shopify-Storefront-Access-Token": accessToken
    //     },
    //     body: JSON.stringify({ query, variables })
    //   });

    //   const productInfo = await response.json();

    //   return productInfo;
    // }

    // function setAvailabilityIndicators(stores, productInfo = {}, variantInfo = {}){

    //   const storeRestrictionName = "82-85 Avenida Carrera 19";
    //   console.log('STAN: ', stores);

    //   const shippingStores = stores.filter(store => (store.available === true && store.location.name === storeRestrictionName)); // Bodega
    //   const pickupStores = stores.filter(store => (store.available === true && store.location.name !== storeRestrictionName)); // Pickups
    //   console.log('Shipping Stores: ', shippingStores);
    //   console.log('Pickup Stores: ', pickupStores);

    //   const options = document.querySelectorAll('.pickup-store__option');
    //   console.log(options);

    //   if (options) {
    //     options.forEach(option => {
    //       const isShip = option.dataset.storeType === 'ship';
    //       const isPick = option.dataset.storeType === 'pick';

    //       console.log('IS SHIP: ', isShip);
    //       console.log('IS PICK: ', isPick);
          
      
    //       // Condiciones para habilitar la opción
    //       const shouldEnable =
    //         (shippingStores.length > 0 && pickupStores.length === 0 && isShip) || // Solo shipping
    //         (shippingStores.length === 0 && pickupStores.length > 0 && (isShip || isPick)) || // Solo pickup
    //         (shippingStores.length > 0 && pickupStores.length > 0 && (isShip || isPick)); // Ambos

    //         console.log('Should Enable: ', shouldEnable);


    //       const type = option.querySelector('.pickup-store__option-type');
    //       if(type){
    //         type.textContent = `Retiro en Tienda`;
    //       }
          
      
    //       // Habilitar o deshabilitar la opción según las condiciones
    //       if (shouldEnable) {
    //         option.classList.remove('pickup-store__option--disabled');

    //         if(isPick){  
              
    //           if(type){
    //             type.textContent = `Retiro en Tienda (${pickupStores.length})`;
    //             if (!type.classList.contains('pickup-store__option-type--available')) {
    //               type.classList.add('pickup-store__option-type--available');
    //             }
                  
    //           }
    //           // setPickupButton(shouldEnable, pickupStores); // True
    //           setPickupInfo(shouldEnable, pickupStores, option, productInfo, variantInfo);
    //         }

    //       } else {
    //         option.classList.add('pickup-store__option--disabled');

    //         if(isPick){    
    //           if (type.classList.contains('pickup-store__option-type--available')) {
    //             type.classList.remove('pickup-store__option-type--available');
    //           }
    //           // setPickupButton(shouldEnable, pickupStores); // False
    //           // setPickupInfo(shouldEnable, pickupStores);
    //         }
    //       }
    //     });
    //   }

    // }

    // function formatToCOP(amount) {
    //   return new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP' }).format(amount);
    // }

  })();

});

